// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line
import '../styles/main.scss';
// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  if ($('[data-fancybox]').length) {
    $('[data-fancybox]').fancybox({
      protect: true,
      buttons: ['close', 'zoom'],
      zoom: true,
    });
  }

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });
  $('#services-read-more').on('click', function (e) {
    e.preventDefault();
    const $contentBlock = $(this)
      .closest('.services')
      .find('.services__content--hidden');
    if ($contentBlock.length > 0) {
      const isOpen = $contentBlock.hasClass('is-open');
      if (!isOpen) {
        const fullHeight = $contentBlock[0].scrollHeight;
        $contentBlock.css('max-height', fullHeight + 'px');
        $contentBlock.addClass('is-open');
        $(this).find('.read-more-text').css('display', 'none');
        $(this).find('.collapse-text').css('display', 'block');
      } else {
        $contentBlock.css('max-height', '0');
        $contentBlock.removeClass('is-open');
        $(this).find('.read-more-text').css('display', 'block');
        $(this).find('.collapse-text').css('display', 'none');
      }
    }
  });

  resizeVideo();
  showSearch();
  addHeaderBackground();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});

function showSearch() {
  if (!$('.search').length) return;

  let hideTimer;

  $('.search').on('mouseenter', '.search__submit', function () {
    clearTimeout(hideTimer);
    $(this).siblings('.search__input').addClass('show');
  });

  $('.search').on('mouseleave', '.search__submit, .search__input', function () {
    const $input = $(this).closest('.search').find('.search__input');

    hideTimer = setTimeout(function () {
      $input.removeClass('show');
    }, 3000);
  });

  $('.search').on('mouseenter', '.search__input', function () {
    clearTimeout(hideTimer);
  });
}

function addHeaderBackground() {
  const $header = $('header');

  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 50) {
      $header.addClass('background');
    } else {
      $header.removeClass('background');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion').forEach((accordion) => {
    accordion.querySelectorAll('.accordion-item').forEach((item) => {
      const button = item.querySelector('.accordion-title');
      const content = item.querySelector('.accordion-content');

      button.addEventListener('click', () => {
        const isActive = item.classList.contains('is-active');

        // Закрываем все
        accordion.querySelectorAll('.accordion-item').forEach((el) => {
          el.classList.remove('is-active');
          el.querySelector('.accordion-content').style.maxHeight = null;
        });

        // Открываем текущий
        if (!isActive) {
          item.classList.add('is-active');
          content.style.maxHeight = `${content.scrollHeight}px`;
        }
      });
    });
  });
});
